import { render, staticRenderFns } from "./UserProjectAlertSetting.vue?vue&type=template&id=700fc012&scoped=true&"
import script from "./UserProjectAlertSetting.vue?vue&type=script&lang=js&"
export * from "./UserProjectAlertSetting.vue?vue&type=script&lang=js&"
import style0 from "./UserProjectAlertSetting.vue?vue&type=style&index=0&id=700fc012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700fc012",
  null
  
)

export default component.exports